<template>
    <div>
        <div id="insights" class="box">
            <account-verification-warning
                v-if="!useAuthStore().isLoggedIn"
                @verify-account="$root.go('v2.account.verify')"
            />
            <insights v-else />
        </div>
    </div>
</template>

<script>
    import AccountVerificationWarning from '../../../app-v2/components/data-views/dashboard/partials/AccountVerificationWarning.vue';
    import Insights from '../sections/Insights.vue';
    import { useAuthStore } from '../../../stores';

    export default {
        /**
         * The component name
         *
         * @type {string}
         */
        name: 'InsightsRouterView',
        components: {
            AccountVerificationWarning,
            Insights
        },

        setup() {
            return {
                useAuthStore
            };
        }
    };
</script>
